// import React from 'react'
// import '../Styles/Footer.css'
// import flogo from '../Resource/footerlogo.png'

// export const Footer = () => {
//   return (
//     <div className='Footer-Container'>

//         <div className='Footer-left-contents'>
//             <img src={flogo} className='Footer-logo'></img>

//             {/* <div className="Footer-Left-content-subscribe-container">
//                 <input
//                 type="email"
//                 className="Footer-Left-content-input"
//                 placeholder="Enter your email"
//                 />
//                 <button className="Footer-Left-content-button">Subscribe</button>
//             </div>

//             <p className="Footer-Left-content-note">
//                 By subscribing, you agree to our Privacy Policy and consent to receive updates from Prasiddh.
//             </p> */}
//         </div>

//         <div className='Footer-Right-contents'>
//             <div className='Footer-right-links-1'>
//                 <h1>Quick Links</h1>
//                 <p><a href='#Home' className='Footer-a-links'>Home</a></p>
//                 <p><a href='#About' className='Footer-a-links'>About</a></p>
//                 <p><a href='#Gallery' className='Footer-a-links'>Gallery</a></p>
//                 <p><a href='#Contact' className='Footer-a-links'>Contact</a></p>
//             </div>
//             <div className='Footer-right-links-1'>
//                 <h1>Follow Us</h1>
//                 <p>Facebook</p>
//                 <p>Instagram</p>
//             </div>
//         </div>

//     </div>
//   )
// }

import React from 'react';
import '../Styles/Footer.css';
import flogo from '../Resource/footerlogo.png';

export const Footer = () => {
  return (
    <div className='Footer-Container'>
      <div className='Footer-left-contents'>
        <img src={flogo} className='Footer-logo' alt="Footer Logo" />
        {/* Optional subscription section - currently commented out */}
      </div>

      <div className='Footer-Right-contents'>
        <div className='Footer-right-links-1'>
          <h1>Quick Links</h1>
          <p><a href='#Home' className='Footer-a-links'>Home</a></p>
          <p><a href='#About' className='Footer-a-links'>About</a></p>
          <p><a href='#Gallery' className='Footer-a-links'>Gallery</a></p>
          <p><a href='#Contact' className='Footer-a-links'>Contact</a></p>
        </div>
        <div className='Footer-right-links-1'>
          <h1>Follow Us</h1>
          <p>
            <a
              href='https://www.facebook.com/prasiddh.eco.village'
              className='Footer-a-links'
              target='_blank'
              rel='noopener noreferrer'
            >
              Facebook
            </a>
          </p>
          <p>
            <a
              href='https://www.instagram.com/prasiddh.eco.village/'
              className='Footer-a-links'
              target='_blank'
              rel='noopener noreferrer'
            >
              Instagram
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
